import { isValidElement } from 'react';

export interface RenderProp {
    (args: any): JSX.Element;
}

export function handleRenderProp(jsxOrRenderProp?: JSX.Element | RenderProp | string, args?: any | undefined) {
    
    if (jsxOrRenderProp) {
        if (typeof jsxOrRenderProp === 'function') {
            return jsxOrRenderProp(args);
        } else if (isValidElement(jsxOrRenderProp) || typeof jsxOrRenderProp === 'string') {
            return jsxOrRenderProp;
        }
    }

    return null;
}
